import { Burger, Group, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconLogout,
  IconSwitchHorizontal,
  IconUser,
} from "@tabler/icons-react";
import { useContext, useState } from "react";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Colors, LogoSmall } from "../../Lib/data";
import { RouteList } from "../../Lib/routes";
import { AppContext } from "../../Pages/Dashboard";

import "./styles.scss";

const Navbar: React.FC = () => {
  const context = useContext(AppContext);
  const [active, setActive] = useState("Billing");

  const [isNavOpen, { toggle: toggleNav, close: closeNav }] =
    useDisclosure(false);
  const links = RouteList.map((route) => (
    <Link
      className={"link"}
      style={{
        display: isNavOpen ? "flex" : "none",
      }}
      data-active={route.label === active || undefined}
      to={route.path}
      key={route.label}
      onClick={(event) => {
        setActive(route.label);
        closeNav();
      }}
    >
      <route.icon className={"linkIcon"} stroke={1.5} />
      <motion.span
        initial={false}
        animate={{
          opacity: isNavOpen ? 1 : 0,
          display: isNavOpen ? "block" : "none",
        }}
        transition={{ duration: 0.3 }}
      >
        {route.label}
      </motion.span>
    </Link>
  ));

  return (
    <>
      <motion.nav
        className="navbar-container"
        initial={{ x: -340 }}
        animate={{ x: isNavOpen ? 0 : -280 }}
        transition={{ duration: 0.3 }}
      >
        <div className={"navbarMain"}>
          <Group className={"header"} justify="space-between">
            <img src={LogoSmall} className="logo" />
            <Burger size={21} opened={isNavOpen} onClick={toggleNav} />
          </Group>
          <div className="flex-col links">{links}</div>
        </div>

        <motion.div
          initial={false}
          animate={{
            opacity: isNavOpen ? 1 : 0,
            display: isNavOpen ? "block" : "none",
          }}
          transition={{ duration: 0.3 }}
          className={"footer"}
        >
          <Text tt="capitalize" fz="xs" ml={15} mb={9} c={Colors.PurplePrimary}>
            {context?.profile?.name}
          </Text>
          <Link to="/d/profile" className={"link"}>
            <IconUser className={"linkIcon"} stroke={1.5} />
            <span>Profile</span>
          </Link>
          <a href="#" className={"link"} onClick={context?.logout}>
            <IconLogout className={"linkIcon"} stroke={1.5} />
            <span>Logout</span>
          </a>
        </motion.div>
      </motion.nav>
      <div className="nav-placeholder"></div>
    </>
  );
};
export default Navbar;
